import React, { useState, useEffect } from "react";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
import { Link } from "react-scroll";
import {
  FcAbout,
  FcBiotech,
  FcBusinessContact,
  FcHome,
  FcPortraitMode,
  FcReadingEbook,
  FcVideoProjector,
  FcDiploma1,
} from "react-icons/fc";

const navItems = [
  { to: "home", icon: FcHome, label: "Home" },
  { to: "about", icon: FcAbout, label: "About" },
  { to: "education", icon: FcReadingEbook, label: "Education" },
  { to: "work", icon: FcPortraitMode, label: "Work Exp" },
  { to: "techstack", icon: FcBiotech, label: "Tech Stack" },
  { to: "projects", icon: FcVideoProjector, label: "Projects" },
  { to: "certificates", icon: FcDiploma1, label: "Certificates" },
  
  { to: "contact", icon: FcBusinessContact, label: "Contact" },
];

const Menus = ({ toggle }) => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const sections = navItems.map((item) => item.to);
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveSection(sections[i]);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="flex flex-col flex-1 overflow-hidden">
      {/* Profile Picture */}
      {toggle && (
        <Zoom>
          <div className="flex justify-center px-4 py-4">
            <div className="relative">
              <div className="w-24 h-24 rounded-full p-0.5 bg-gradient-to-br from-[#f29f67] to-[#3b8ff3]">
                <img
                  src="Profile-Ayush.jpeg"
                  alt="Ayush Rai"
                  className="w-full h-full rounded-full object-cover border-2 border-[#0f0f1a]"
                />
              </div>
              <span className="absolute bottom-0.5 right-0.5 w-3 h-3 bg-green-400 rounded-full border-2 border-[#0f0f1a]" />
            </div>
          </div>
        </Zoom>
      )}

      {/* Nav Items */}
      <nav className="flex-1 px-2 py-2 space-y-1 overflow-y-auto">
        {toggle ? (
          <Fade left>
            <div className="space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  spy={true}
                  smooth={true}
                  offset={-80}
                  duration={400}
                >
                  <div
                    className={`
                      flex items-center gap-3 px-3 py-2.5 rounded-xl cursor-pointer
                      transition-all duration-200 group
                      ${activeSection === item.to
                        ? "bg-white/10 text-[#f29f67] border-l-2 border-[#f29f67]"
                        : "text-gray-400 hover:bg-white/8 hover:text-[#f29f67]"
                      }
                    `}
                  >
                    <item.icon className="text-lg flex-shrink-0" />
                    <span className="text-sm font-medium truncate">{item.label}</span>
                  </div>
                </Link>
              ))}
            </div>
          </Fade>
        ) : (
          <div className="space-y-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                spy={true}
                smooth={true}
                offset={-80}
                duration={400}
                title={item.label}
              >
                <div
                  className={`
                    flex items-center justify-center p-2.5 rounded-xl cursor-pointer
                    transition-all duration-200
                    ${activeSection === item.to
                      ? "bg-white/10"
                      : "hover:bg-white/8"
                    }
                  `}
                >
                  <item.icon className="text-xl" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </nav>

      {/* Bottom gradient line */}
      <div className="h-px mx-3 my-3 bg-gradient-to-r from-transparent via-white/10 to-transparent" />
    </div>
  );
};

export default Menus;